import { Module } from 'vuex'
// import { arrSort } from '$utils/common'
import { RUN_SIDE } from '@common/loan-act/env'
import { ACT_CODE } from '$utils/act-config'
import { queryActConf, queryIntegral } from '$services/act'

const actModule: Module<any, any> = {
  namespaced: true,
  state: {
    _actConf: '',
    _integralConf: ''
  },
  getters: {
    actInfo(state) {
      return {
        ...state._actConf.actInfoResp,
      }
    },
    ruleGroup(state) {
      if (state._actConf.ruleGroupList) {
        return state._actConf.ruleGroupList.filter((el: any) => el.actCode === ACT_CODE)[0]
      } else {
        return {}
      }
    },
    status(state) {
      // -3:已删除; -2:待提交; -1: 待审核; 0:待发布; 1:已启用; 2:进行中; 3:暂停; 4:结束; 5:活动正在结束
      const { actStatus } = state._actConf.actInfoResp
      if (actStatus < 2) {
        return 'unopen'
      } else if (actStatus === 2) {
        return 'running'
      } else {
        return 'over'
      }
    },
    usableIntegral(state) {
      if (state._integralConf && RUN_SIDE !== 'h5') {
        return state._integralConf[0].awardPondList[0].usableIntegral
      } else {
        return 0
      }
    },
    integralCode(state) {
      return state._integralConf[0].integralCode
    },
    // awardRespBOS(state) {
    //   if (state._integralConf) {
    //     return state._integralConf[0].awardPondList[0].awardRespBOS
    //   } else {
    //     return [
    //       { awardCode: 'XJlkOBkOdy' },
    //       { awardCode: 'XJ2QjOQ9ig' },
    //       { awardCode: 'DYEgCcEtDi' },
    //     ]
    //   }
    // },
  },
  mutations: {
    updateActConf(state, data) {
      state._actConf = data
    },
    updateIntegralConf(state, data) {
      state._integralConf = data
    }
  },
  actions: {
    async init({ dispatch }, force = true) {
      await dispatch('slientLogin', null, { root: true }).catch(() => { })
      await dispatch('getActConf', { force })
      // if (rootState.common.loginState) {
      //   await dispatch('getIntegral', { force })
      // }
    },
    /** 查询活动公共配置 */
    getActConf({ commit, state, getters }, { force = true } = {}) {
      force && console.log('强制刷新 queryActInfo')
      if (typeof state._actConfig === 'object' && !force) {
        return Promise.resolve([getters.actInfo])
      }
      return queryActConf()
        .then((data: any) => {
          commit('updateActConf', data)
          return data
        })
        .catch((e: any) => {
          console.log('[queryActConf] 获取活动信息失败', e)
        })
    },
    /** 查询抽奖机会 */
    getIntegral({ commit, state, getters }, { force = true } = {}) {
      force && console.log('强制刷新 getIntegral')
      if (typeof state._actConfig === 'object' && !force) {
        return Promise.resolve([getters.actInfo])
      }
      return queryIntegral()
        .then((data: any) => {
          commit('updateIntegralConf', data)
          return data
        })
        .catch((e: any) => {
          console.log('[queryIntegral] 获取活动信息失败', e)
        })
    }
  },
}

export default actModule
